query MfaSessionDetails($runId: ConditionID!) {
	mfa_session_runs(run_id_eq: $runId) {
		run_id
		session_name
		run_time
		run_updated_at
		user_name
		custom_fields
		app
        app_id
		app_version
		mobile_kit
		device_manufacturer
		device_model
		device_type
		os
		os_version
		app_build_number
		product_version
	}
}
